module.exports = __webpack_public_path__ + "img/0yuan.5802e2e5.png";